import {Injectable} from '@angular/core';
import * as globals from '../settings';
import {LotteriesService} from '../lotteries.service';
import {CurrencyService} from '../_services/currency.service';
import {Router} from '@angular/router';
import {SubscriptionsService} from '../_services/subscriptions.service';
import {Subscription} from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class ScratchService {
    languageChange: Subscription;
    showLang: string;

    constructor(private lotteryService: LotteriesService,
                private currencyService: CurrencyService,
                private router: Router,
                private subscriptionsService: SubscriptionsService) {
        this.languageChange = this.subscriptionsService.getLanguage().subscribe(lang => {
            this.showLang = lang;
        });
    }

    buyPackage(id) {
        return new Promise(resolve => {
            const playerShares = localStorage.getItem('playerShares') === '1' ? '&playerShares=' + 1 : '';
            const DataString = localStorage.getItem('playerDetails');
            const dataJson = JSON.parse(DataString);
            let membId = 0;
            let sessionId = '';
            let data = '';
            if (DataString != null) {
                membId = dataJson.MemberID;
                sessionId = dataJson.sessionId;
                data = 'sessionId=' + sessionId + '&packageId=' + id + playerShares;
            } else {
                membId = 0;
                sessionId = '';
                data = 'sessionId=0&packageId=' + id;
            }
            data += '&currency=' + this.currencyService.currency.Code;
            this.lotteryService.postData(`${globals.appDomain}/cart/addSingleTicket/${membId}/cast_scratchService.json`, data)
                .subscribe(
                    result => {
                        const cartItem = result.addCartMessage;
                        const thisCart = [];
                        const lastItem = cartItem.Cart.Packages.pop();
                        thisCart.push(lastItem);
                        const storedCart = localStorage.getItem('cart');
                        if (storedCart === null) {
                            localStorage.setItem('cart', JSON.stringify(thisCart));
                        } else {
                            const newStoredCart = JSON.parse(storedCart);
                            newStoredCart.push(thisCart[0]);
                            localStorage.setItem('cart', JSON.stringify(newStoredCart));
                        }
                        // this.router.navigate(['/' + this.showLang, 'cart']);

                        resolve(result);
                    }
                );
        });
    }
}
